import { Injectable, Injector } from "@angular/core";
import { FeatureEditorService } from '@farris/ui-feature-editor';
import { FormNotifyService } from "../form-notify.service";
import { map, switchMap, tap } from "rxjs/operators";
import { FormLoadingService } from "../form-loading/form-loading.service";
import { FeatureDataService } from './feature-data.service';
import { LanguageService } from '../languag.service';
import { of } from "rxjs";

@Injectable()
export class FeatureEditService {
  constructor(
    private injector: Injector,
    private featureEditorService: FeatureEditorService,
    private featureDataService: FeatureDataService,
    private loadingService: FormLoadingService,
    private notifyService: FormNotifyService,
    private languageService: LanguageService,
  ) { }

  public edit(materialId: string, materialFeatureId?: string, options?: any) {
    if (!materialId) {
      throw new Error('[FeatureEditService]ç©æidä¸è½ä¸ºç©ºï¼');
    }
    if (!options) {
      options = {};
    }
    if (typeof options === 'string' && options.startsWith('{') && options.endsWith('}')) {
      options = JSON.parse(options);
    }
    options.getHelpInfo = this.featureDataService.getHelpInfo;
    this.loadingService.show();
    return this.featureDataService.getFeaturesByMaterialId(materialId).pipe(
      tap((result: any) => {
        this.loadingService.hide();
        const returnValue = result || null;
        if (returnValue) {
          const featureInfo = JSON.parse(returnValue);
          const props = featureInfo.props || null;
          if (!props || props.length < 1) {
            this.notifyService.warning(this.languageService.propsIsEmpty);
            return;
          }
          this.featureEditorService.show(props, options);
        } else {
          this.notifyService.error(this.languageService.propsIsEmpty);
        }
      })
    );
  }
  private buildFeatures(materialId: string, materialFeatureId?: string) {
    const features$ = this.featureDataService.getFeaturesByMaterialId(materialId);
    return features$.pipe(
      switchMap(featureSet => {
        if (materialFeatureId) {
          const configedFeatures$ = this.featureDataService.getConfigedValueByFeatureId(materialFeatureId, materialFeatureId);
          return configedFeatures$.pipe(
            map(defaultConfigs => {
              const featureTemplate = featureSet.props;
              const features = this.mergeFeatures(featureTemplate, defaultConfigs);
              return features;
            })
          );
        } else {
          return of(featureSet.props);
        }
      })
    );

  }
  private mergeFeatures(featureTemplate: any, defaultConfigs: any) {
    return null;
  }
}